import React from 'react';
import history from '../Utils/history';
import { Helper } from '../Utils';
import { routes } from '../Routing/routes';

export class ExternalLogin extends React.Component {
	constructor(props: any) {
		super(props);

		window.addEventListener('message', this.handler, false);
	}
	handler = (event) => {
		if (event.origin !== (window as any).CP_URL) return;
		if (event.data?.access_token) {
			const adres = window.location.href;
			const whereYouGo =
				adres.indexOf('redirectTo=') > 0 ? adres.trimRight().slice(adres.indexOf('redirectTo=') + 11, adres.length) : '';
			window.sessionStorage.setItem('refresh_token', event.data?.refresh_token);
			window.sessionStorage.setItem('user_name', event.data?.user_name);
			window.localStorage.setItem('access_token', event.data?.access_token);
			event.source.postMessage(event.data?.returnMessage, event.origin);
			// setTokenUpdated(true)
			window.removeEventListener('message', this.handler);
			window.location.href = whereYouGo;
		}
	};

	goToLoginPage = () => {
		history.push(routes.login);
	};
	componentDidMount() {
		Helper.setLoader(true);
		setTimeout(this.goToLoginPage, 15000);
	}
	componentWillUnmount() {
		Helper.setLoader(false);
		window.removeEventListener('message', this.handler);
	}
	render() {
		return <div></div>;
	}
}
